import { render, staticRenderFns } from "./GetTheApp.vue?vue&type=template&id=e1d75964&"
import script from "./GetTheApp.vue?vue&type=script&lang=js&"
export * from "./GetTheApp.vue?vue&type=script&lang=js&"
import style0 from "./GetTheApp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports